import { FETCH_CLIENTS_RELATORY_INIT } from './ClientsRelatoryActions'

const INITIAL_STATE = {
  items: [],
  totalSize: 0,
  page: 1,
  sizePerPage: 10,
  filters: [],
  companies: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CLIENTS_RELATORY_INIT.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        totalSize: action.payload.data.meta.total,
        page: action.payload.data.meta.current_page,
        sizePerPage: action.payload.data.meta.per_page,
        filters: action.payload.filters,
        companies: action.payload.data.companies
      }
    case "CLEAR_ACTION_CLIENTS":
      return {
        ...state,
        filters: []
      }
    default:
      return state
  }
}

export const getClientsRelatoryListData = state => {
  return {
    items: state.clients_relatory.items,
    page: state.clients_relatory.page,
    sizePerPage: state.clients_relatory.sizePerPage,
    totalSize: state.clients_relatory.totalSize,
    filters: state.clients_relatory.filters,
    companies: state.clients_relatory.companies
  }
}